module.exports = __webpack_public_path__ + "img/arrow-left-circle.d7056b61.svg";